import { PathUtils } from "@adobe/aem-spa-page-model-manager";
import { PRODUCT_KEYS } from "./products";
import FundsStore from "@ipru-common/store/FundsStore.js";
import { FUND_NAMES, MVPF_FUND_CODE } from "./SiteConstants";
import { getDefaultPerformanceValue } from "@ipru-common/utils/SavingsQuote/SavingsQuoteUtils";

export const getDefaultSelectedFund = () => {
  const currentProduct = PathUtils.getMetaPropertyValue("current_product");
  const productWiseDefaultFund = {
    [PRODUCT_KEYS.GIFT_CITY]: "ICICI Life US Growth Fund",
    [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: "ICICI Life US Technology Advantage Fund",
    [PRODUCT_KEYS.SIGNATURE_PENSION]: FUND_NAMES.PENSION_MULTI_CAP_GROWTH_FUND.value,
  };
  return productWiseDefaultFund[currentProduct] || FundsStore?.getDefaultFund?.()?.Fund || "Opportunities Fund";
};

export const DEFAULT_SELECTED_FUND = getDefaultSelectedFund();
export const ATS_FUNDS = ["Money Market Fund", "Income Fund"];

export const getDefaultPastPerformanceValue = () => {
  const defaultFund = FundsStore?.getFunds()?.find((fund) => fund?.Fund === getDefaultSelectedFund());

  let pastPerformancePercent = 18.57;

  if (defaultFund) {
    const { minValue } = getDefaultPerformanceValue(defaultFund);
    pastPerformancePercent = minValue;
  }
  return pastPerformancePercent;
};

const DEFAULT_NUDGE_DATES = {
  StartDate: new Date("2026-08-18T00:00:00"),
  finalDate: new Date("2026-08-26T00:00:00"), // will end on [25th night]
};

const productWiseDefaultFund = {
  [MVPF_FUND_CODE]: {
    StartDate: new Date("2026-08-18T00:00:00"),
    finalDate: new Date("2026-08-26T00:00:00"),
  },
};
export const getFundNudgeDates = (fundCode) => {
  return productWiseDefaultFund[fundCode] || DEFAULT_NUDGE_DATES;
};
